import React from "react";

export const WaveBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" style={{ zIndex: 0 }}>
      {/* Background base color (Slate fallback) */}
      <div className="absolute inset-0 bg-slate-50" />

      <svg
        className="absolute w-full h-full"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <defs>
          <linearGradient id="wave-burgundy" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6F003C" />
            <stop offset="100%" stopColor="#5A0030" />
          </linearGradient>
          <linearGradient id="wave-red" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF0000" />
            <stop offset="100%" stopColor="#CC0000" />
          </linearGradient>
          <linearGradient id="wave-teal-dark" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#004B5B" />
            <stop offset="100%" stopColor="#003A47" />
          </linearGradient>
          <linearGradient id="wave-teal-light" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00B19C" />
            <stop offset="100%" stopColor="#008E7D" />
          </linearGradient>
        </defs>

        {/* STRATEGIE: 
           Wir "stapeln" die Wellen von hinten nach vorne.
           Jede Welle füllt den Bereich von Oben (y=0) bis zu ihrer Kurve.
           Dadurch verdeckt die obere Welle immer einen Teil der unteren.
        */}

        {/* LAYER 4 (Ganz unten): Hell-Türkis */}
        {/* Füllt einfach den ganzen Bildschirm */}
        <rect width="2880" height="900" fill="url(#wave-teal-light)" />

        {/* LAYER 3: Dunkel-Türkis */}
        {/* Soll bei ca. 75% Höhe enden (ca. 675px) */}
        <path
          className="wave wave-3"
          fill="url(#wave-teal-dark)"
          opacity="1"
          d="M0,0 L0,675 
             C400,725 700,625 1000,675 
             C1250,715 1350,650 1440,675
             C1840,725 2140,625 2440,675 
             C2690,715 2790,650 2880,675
             L2880,0 Z"
        />

        {/* LAYER 2: Rot */}
        {/* Soll bei ca. 50% Höhe enden (ca. 450px) */}
        <path
          className="wave wave-2"
          fill="url(#wave-red)"
          opacity="1"
          d="M0,0 L0,450 
             C300,410 600,490 900,450 
             C1200,410 1350,480 1440,450
             C1740,410 2040,490 2340,450 
             C2640,410 2790,480 2880,450
             L2880,0 Z"
        />

        {/* LAYER 1 (Ganz oben): Burgundy */}
        {/* Soll bei ca. 25% Höhe enden (ca. 225px) */}
        <path
          className="wave wave-1"
          fill="url(#wave-burgundy)"
          opacity="1"
          d="M0,0 L0,225 
             C360,265 600,185 920,225 
             C1200,265 1360,195 1440,225
             C1800,265 2040,185 2360,225 
             C2640,265 2800,195 2880,225
             L2880,0 Z"
        />
      </svg>
    </div>
  );
};